export default {
  page: function () {
    this.loadBoardingPlaces()
  }
}
